export default [
  {
    path: '/app',
    component: () => import('../components/Web/AppLayout.vue'),
    children: [
      {
        path: 'home',
        name: 'app-home',
        component: () => import('../views/Web/Home-Page.vue')
      },
      {
        path: 'appointment',
        name: 'app-appointment',
        component: () => import('../views/Web/Appointment-Page.vue')
      },
      {
        path: 'screening-appointment',
        name: 'app-screening-appointment',
        component: () => import('../views/Web/ScreeningAppointment-Page.vue')
      },
      {
        path: 'inquire',
        name: 'app-inquire',
        component: () => import('../views/Web/Inquire-Page.vue')
      },
      {
        path: 'stations',
        name: 'app-stations',
        component: () => import('../views/Web/Stations-Page.vue')
      },
      {
        path: ':catchAll(.*)',
        name: 'app-appNotFound',
        component: () => import('../views/Web/Error/Error-404.vue')
      }
    ]
  }
]
